import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export interface PayloadDemonstrativoMetaFamiliaById {
  id: number
}

export interface PayloadDemonstrativoMetaFamiliaByDateAndId extends PayloadDemonstrativoMetaFamiliaById {
  iniDate: string
	endDate: string
}

export const demonstrativoMetaFamiliaServiceById = async (
  payload: PayloadDemonstrativoMetaFamiliaById
): Promise<ResponseAPI> => {
  const response = await api.get(
    `demonstrativometafamilia/2026-05-25/2026-05-31%27`
  );

	console.log(response.data);
  return response.data;
};

export const demonstrativoMetaFamiliaServiceByDateAndId = async (
  payload: PayloadDemonstrativoMetaFamiliaByDateAndId
): Promise<ResponseAPI> => {
  const response = await api.get(
    `demonstrativometafamilia/${payload.iniDate}/${payload.endDate}%${payload.id}`
  );
  return response.data;
};







